import clsx from 'clsx';
import React from 'react';

import SubtaskReportItem from './SubtaskReportItem/SubtaskReportItem';

import { SubtaskReport } from '../types';
import SubtaskReportVerticalItem from './SubtaskReportItem/SubtaskReportVerticalItem';

type SubtaskReportsListProps = {
  subtaskReports: SubtaskReport[];
  isReportsEnabled?: boolean;
};

const SubtaskReportsList = ({ subtaskReports, isReportsEnabled }: SubtaskReportsListProps) => {
  if (subtaskReports.length < 1) {
    return (
      <div
        className={clsx(
          'tw-absolute tw-inset-0',
          'tw-w-full tw-flex tw-items-center tw-justify-center'
        )}
      >
        <div className={clsx('tw-h-auto tw-flex tw-flex-col tw-flex-grow', 'tw-text-center')}>
          <h4
            className={clsx(
              'tw-text-[14px] tw-text-cfo-grey-600 tw-font-brandonTextMedium',
              'tw-leading-[20px]',
              'tw-pt-[12px]'
            )}
          >
            No reports are available
          </h4>
          <span className={clsx('tw-text-cfo-grey-600', 'tw-leading-[20px]')}>
            This page will display all report files that have been uploaded to the account.
          </span>
        </div>
      </div>
    );
  }

  return (
    <>
      {isReportsEnabled ? (
        <>
          <div
            className={clsx(
              'tw-flex tw-flex-col',
              ' tw-overflow-y-auto tw-overflow-x-hidden' // 4.5 tiles at ~90px each
            )}
            style={{
              rowGap: '10px',
              paddingRight: '10px',
              maxHeight: subtaskReports.length > 5 ? '460px' : 'auto',
            }}
          >
            {subtaskReports.map((subtaskReport) => (
              <SubtaskReportVerticalItem
                key={`tc_${subtaskReport.id}`}
                subtaskReport={subtaskReport}
              />
            ))}
          </div>
        </>
      ) : (
        <div className={clsx('tw-flex tw-mx-[13px] tw-mt-[10px] tw-mb-[15px]')}>
          {subtaskReports.map((subtaskReport) => (
            <SubtaskReportItem key={`tc_${subtaskReport.id}`} subtaskReport={subtaskReport} />
          ))}
        </div>
      )}
    </>
  );
};

export default SubtaskReportsList;
